// frontend/src/services/announcement.api.js
import axios from '../utils/axiosConfig';

const announcementAPI = {
  // =================== PUBLIC ENDPOINTS ===================
  
  // Get active announcements
  getActiveAnnouncements: async () => {
    const response = await axios.get('/announcements/active');
    return response.data;
  },

  // Track announcement click
  trackAnnouncementClick: async (announcementId) => {
    const response = await axios.post(`/announcements/${announcementId}/click`);
    return response.data;
  },

  // Get current promotion
  getCurrentPromotion: async () => {
    const response = await axios.get('/announcements/promotion/current');
    return response.data;
  },

  // Track promotion click
  trackPromotionClick: async (promotionId) => {
    const response = await axios.post(`/announcements/promotion/${promotionId}/click`);
    return response.data;
  },

  // =================== ADMIN ENDPOINTS ===================
  
  // Get all announcements (admin)
  getAllAnnouncements: async (params = {}) => {
    const response = await axios.get('/announcements/admin', { params });
    return response.data;
  },

  // Create announcement (admin)
  createAnnouncement: async (data) => {
    const response = await axios.post('/announcements', data);
    return response.data;
  },

  // Update announcement (admin)
  updateAnnouncement: async (id, data) => {
    const response = await axios.put(`/announcements/${id}`, data);
    return response.data;
  },

  // Delete announcement (admin)
  deleteAnnouncement: async (id) => {
    const response = await axios.delete(`/announcements/${id}`);
    return response.data;
  },

  // Get all promotions (admin)
  getAllPromotions: async (params = {}) => {
    const response = await axios.get('/announcements/promotions/admin', { params });
    return response.data;
  },

  // Create promotion (admin)
  createPromotion: async (data) => {
    const response = await axios.post('/announcements/promotions', data);
    return response.data;
  },

  // Update promotion (admin)
  updatePromotion: async (id, data) => {
    const response = await axios.put(`/announcements/promotions/${id}`, data);
    return response.data;
  },

  // Delete promotion (admin)
  deletePromotion: async (id) => {
    const response = await axios.delete(`/announcements/promotions/${id}`);
    return response.data;
  },
};

export default announcementAPI;